<template>
    <toolbar-option>
        <template slot="primary">
            <dropdown
                :options="options"
                :value="value"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const DEFAULT_VALUE = 'text';

export default {
    name: 'input-type',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Input Type',
            value: DEFAULT_VALUE,
        };
    },

    computed: {
        options() {
            return [
                { text: 'Text', value: 'text' },
                { text: 'Password', value: 'password' },
                { text: 'Hidden', value: 'hidden' },
                { text: 'Date', value: 'date' },
            ];
        },
    },

    watch: {
        changedOption({ option, value }) {
            if (option === 'input-validation') {
                switch (value) {
                    case 'email':
                        this.selectedElements[0].inputTypeNew = 'email';
                        break;

                    case 'telephone':
                        this.selectedElements[0].inputTypeNew = 'tel';
                        break;

                    case 'url':
                        this.selectedElements[0].inputTypeNew = 'url';
                        break;

                    default:
                        this.value = DEFAULT_VALUE;
                }
            }
        },
    },

    methods: {
        onSelectedElement() {
            this.value = this.selectedElements[0].inputTypeNew || DEFAULT_VALUE;
        },

        // note that inputTypeNew is also updated by the input-validation option
        onInput(valueNew) {
            this.value = valueNew;
            this.selectedElements[0].inputTypeNew = valueNew;
            this.onOptionChange(valueNew);
            this.setChangedData(true);
        },
    },
};
</script>
